import { getPaginationApiParams } from '../../../../utils/pagination'
import { toOrderingList } from '../../../../utils/sort'
import {
  DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT,
  getDocFlowAddRecipientFieldsEditInitialValues,
} from '../../DocFlowAddRecipientFields'
import {
  DocFlowMappingResultTableCell,
  DocFlowMappingResultTableFilterName,
} from '../DocFlowMappingResultTable'

import {
  DOC_FLOW_MAPPING_RECIPIENT_MODAL_FIRST_POSITION,
  DOC_FLOW_MAPPING_RECIPIENT_MODAL_PAGE_SIZE,
} from './DocFlowMappingRecipientModal.constants'

export function getDocFlowMappingRecipientModalCounterKey(filterValues) {
  const isMapped =
    filterValues[DocFlowMappingResultTableFilterName.Mapped] === true
  const isUnmapped =
    filterValues[DocFlowMappingResultTableFilterName.Unmapped] === true

  switch (true) {
    case isUnmapped && !isMapped:
      return 'DocFlow.MappingRecipientModalUnmappedCounterKey'

    case isMapped && !isUnmapped:
      return 'DocFlow.MappingRecipientModalMappedCounterKey'

    default:
      return 'DocFlow.MappingRecipientModalCounterKey'
  }
}

export function getDocFlowMappingRecipientModalListParams({
  filterValues,
  ordering,
  position,
}) {
  return {
    ...getPaginationApiParams({
      page: position,
      pageSize: DOC_FLOW_MAPPING_RECIPIENT_MODAL_PAGE_SIZE,
    }),
    filters: filterValues,
    ordering: toOrderingList(ordering),
  }
}

export function toDocFlowMappingRecipientModalQueueItem({ data, position }) {
  return data.items.length > 0
    ? { item: data.items[0], position, total: data.pagination.total }
    : null
}

export function hasDocFlowMappingRecipientModalPrevious(position) {
  return position > DOC_FLOW_MAPPING_RECIPIENT_MODAL_FIRST_POSITION
}

export function hasDocFlowMappingRecipientModalNext({ position, total }) {
  return position < total
}

export function getDocFlowMappingRecipientModalQueueItemAfterSave({
  currentQueueItem,
  nextQueueItem,
}) {
  return currentQueueItem === null ||
    currentQueueItem.item.id === nextQueueItem.item.id
    ? currentQueueItem
    : {
        ...nextQueueItem,
        position: currentQueueItem.position + 1,
        total: currentQueueItem.total,
      }
}

export function getDocFlowMappingRecipientModalInitialValues(item) {
  // Formik reinitializes only on a deep change, so the id keeps documents with equal fields apart
  return {
    ...getDocFlowAddRecipientFieldsEditInitialValues(item),
    [DocFlowMappingResultTableCell.id]: item.id,
  }
}

export function getDocFlowMappingRecipientModalRecipientId(values) {
  return values[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]?.value
}

export function isDocFlowMappingRecipientModalRecipientChanged({
  item,
  values,
}) {
  return (
    getDocFlowMappingRecipientModalRecipientId(values) !==
    item[DocFlowMappingResultTableCell.Recipient]?.id
  )
}

export function getDocFlowMappingRecipientModalSuggestions({ item, values }) {
  const recipientId = getDocFlowMappingRecipientModalRecipientId(values)

  return item[DocFlowMappingResultTableCell.SuggestedRecipients].filter(
    ({ id }) => id !== recipientId
  )
}
